import { render, staticRenderFns } from "./ImportDP.vue?vue&type=template&id=43d65d2e&scoped=true&lang=html&"
import script from "./ImportDP.vue?vue&type=script&lang=js&"
export * from "./ImportDP.vue?vue&type=script&lang=js&"
import style0 from "./ImportDP.vue?vue&type=style&index=0&id=43d65d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d65d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d65d2e')) {
      api.createRecord('43d65d2e', component.options)
    } else {
      api.reload('43d65d2e', component.options)
    }
    module.hot.accept("./ImportDP.vue?vue&type=template&id=43d65d2e&scoped=true&lang=html&", function () {
      api.rerender('43d65d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directPayments/sendbox/ImportDP.vue"
export default component.exports